export default __webpack_public_path__ + "static/media/signup-icon-blue.00c93e75.svg";